import { Suspense } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import ProductContainer from "./ProductContainer";
import * as UI from "../../../../../../modules/ui-kit";
import SessionPersistentFiltersService from "../../../../app/SessionPersistentFiltersService";
import SessionStorageAdapter from "../../../../infrastructure/SessionStorageAdapter";
import ProductCardInFinder from "../../../features/product-finder/ProductCardInFinder";
import ProductFinder from "../../../features/product-finder/ProductFinder";


const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > div:last-of-type {
        align-items: flex-end;
        display: flex;
        flex-direction: row;
        gap: 8px;
        justify-content: flex-end;
    }
`;

const persistentFiltersService = new SessionPersistentFiltersService(
    new SessionStorageAdapter(),
    "products-console:finder",
);

export default function ProductSelector(props) {
    const { bimClassID, onChange, value } = props;

    const [Dialog, open, close] = useDialog();

    function onSelect(product) {
        onChange(
            product
                ? {
                    brand: product.data?.brand,
                    naturalKey: product.recordedBy?.metadata?.naturalKey,
                }
                : undefined
        );
        close();
    }

    return (
        <Styled>
            {
                value && (
                    <Suspense fallback={ <UI.Bone height="1.6rem" width="16rem" /> }>
                        <ProductContainer
                            brandID={ value?.brand?.id }
                            id={ value?.id }
                            naturalKey={ value?.naturalKey }
                        />
                    </Suspense>
                )
            }
            <div>
                <UI.Button
                    $size="large"
                    onClick={ open }
                >
                    { value ? "Change Product" : "Select Product" }
                </UI.Button>
                <UI.Button
                    $size="large"
                    onClick={ () => onSelect(undefined) }
                >
                    Remove Product
                </UI.Button>
            </div>
            <Dialog>
                <ProductFinder
                    ProductComponent={ ProductCardInFinder }
                    limit={
                        bimClassID ? { bimClasses: [bimClassID] } : {}
                    }
                    onSelect={ onSelect }
                    persistentFiltersService={ persistentFiltersService }
                />
            </Dialog>
        </Styled>
    );
}
